import { Component, AfterViewInit, OnDestroy } from "@angular/core";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements AfterViewInit, OnDestroy {
  title = "s9trucks_web";

  tooltipElement: HTMLElement | null = null;
  tooltipListener: any;

  ngAfterViewInit(): void {
    this.tooltipElement = document.createElement('div');
    this.tooltipElement.className = 'custom-pac-tooltip';
    this.tooltipElement.style.display = 'none';
    document.body.appendChild(this.tooltipElement);

    this.tooltipListener = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const pacItem = target.closest('.pac-item') as HTMLElement;
      if (pacItem) {
        const address = pacItem.innerText.trim().replace(/\n/g, ' ');
        this.tooltipElement!.innerHTML = `
          <div class="tooltip-header">Full Address</div>
          <div class="tooltip-body">${address}</div>
        `;
        const rect = pacItem.getBoundingClientRect();
        const container = pacItem.closest('.pac-container') as HTMLElement;
        let left = rect.right + 15;
        if (container) {
          left = container.getBoundingClientRect().right + 15;
        }
        
        if (left + 300 > window.innerWidth) {
            left = rect.left - 315;
            this.tooltipElement!.classList.add('tooltip-left');
        } else {
            this.tooltipElement!.classList.remove('tooltip-left');
        }

        this.tooltipElement!.style.left = left + 'px';
        this.tooltipElement!.style.top = rect.top + 'px';
        this.tooltipElement!.style.display = 'block';
      } else if (this.tooltipElement && !target.closest('.custom-pac-tooltip')) {
        this.tooltipElement!.style.display = 'none';
      }
    };

    document.addEventListener('mouseover', this.tooltipListener);
  }

  ngOnDestroy(): void {
    if (this.tooltipListener) {
      document.removeEventListener('mouseover', this.tooltipListener);
    }
    if (this.tooltipElement && this.tooltipElement.parentNode) {
      this.tooltipElement.parentNode.removeChild(this.tooltipElement);
    }
  }
}
